import React from "react"
import HyperDiv from "../../../../ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import SubH2 from "../../Global/atoms/Text/SubH2"
import FormFieldLabel from "../atoms/FormFieldLabel"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import InfoBubble from "../../Global/atoms/InfoBubble"

interface Props extends React.ComponentProps<"div"> {
	label: string
	tooltip?: string
	centerSpaceMultiplier?: number
	tooltipBelowInputField?: boolean
	containerStyle?: React.CSSProperties
	children?: React.ReactNode
}

const HorizontalFormField = ({
	label,
	tooltip,
	centerSpaceMultiplier = 1,
	tooltipBelowInputField,
	containerStyle,
	children,
}: Props) => {
	const { isMobile } = useScreenType()
	const labelSpaceProportion = isMobile ? 3 : tooltipBelowInputField ? 1 : 1.5
	const inputSpaceProportion = isMobile
		? 4
		: tooltipBelowInputField
		? 6.5 * centerSpaceMultiplier
		: 5 * centerSpaceMultiplier
	const tooltipSpaceProportion = 3.5

	return (
		<HyperDiv
			direction="column"
			style={{
				padding: "8px 16px",
				...containerStyle,
			}}
		>
			<HyperDiv direction="row" centeredY>
				<HyperDiv flex={labelSpaceProportion}>
					<FormFieldLabel children={label} />
				</HyperDiv>

				<Whitespace h x=".5" />
				<HyperDiv flex={inputSpaceProportion} direction="column">
					{children}
				</HyperDiv>

				{!isMobile && !tooltipBelowInputField && (
					<HyperDiv flex={tooltipSpaceProportion}>
						{tooltip && <InfoBubble tooltipText={tooltip} />}
					</HyperDiv>
				)}
			</HyperDiv>

			{tooltipBelowInputField && (
				<>
					<Whitespace x=".5" />
					<HyperDiv direction="row">
						<HyperDiv flex={labelSpaceProportion}>{/* Empty Space */}</HyperDiv>
						{tooltip && (
							<>
								<Whitespace h x=".5" />
								<HyperDiv flex={inputSpaceProportion}>
									<SubH2>{tooltip}</SubH2>
								</HyperDiv>
							</>
						)}
					</HyperDiv>
				</>
			)}
		</HyperDiv>
	)
}

export default HorizontalFormField
